// ** React Imports
import { useEffect, useRef, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore, LeadActivityHistoryStore, ActivityHistoryDialogStore, LeadActivityCadenceStore, CadenceListDialogStore, LeadActivityOutcomeStore, ActivityOutcomes, LeadActivityEmailStore } from 'src/stores/LeadStore';
import { getActivityEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import DoActivityOutcomes from './DoActivityOutcomes';
import StandardSkeleton from '../../common/StandardSkeleton';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivityInboundEmail = () => {
    const outcomesRecord = LeadActivityOutcomeStore.useState(s => s.record);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead);
    const [emailFrom, setemailFrom] = useState(outcomesRecord.emailFrom);
    const [hasLoaded, setHasLoaded] = useState(false);
        
    const emailMessage = LeadActivityEmailStore.useState(s => s.record);
        
    const [emailBodyError, setEmailBodyError] = useState(false);
    const [emailSubjectError, setEmailSubjectError] = useState(false);
    const [emailFromError, setEmailFromError] = useState(false);

    useEffect(() => {
        const fetchOutcomes = async () => {
            const response = await client.get(leadEndpoints.getactivityoutcomes.replace('{leadid}', "" + selectedLead?.id.toString()));
            LeadActivityOutcomeStore.update(s => { s.record = response.data });
            setemailFrom(response.data.emailFrom);
            
            LeadActivityEmailStore.update(s => { s.record.leadId = response.data.leadId });
            LeadActivityEmailStore.update(s => { s.record.emailBody = response.data.emailBody });
            LeadActivityEmailStore.update(s => { s.record.emailTo = response.data.emailTo });
            LeadActivityEmailStore.update(s => { s.record.emailFrom = response.data.emailFrom });
            LeadActivityEmailStore.update(s => { s.record.emailSubject = response.data.emailSubject });
            LeadActivityEmailStore.update(s => { s.record.userCustomerDetailsId = response.data.userCustomerDetailsId });

            setHasLoaded(true);

            if (response.data.hasEmailFromError) {
                alert('Need to handle email error here');
            }

        }
        if (selectedLead != null) fetchOutcomes();
    }, [])

    const handleSubjectTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        LeadActivityOutcomeStore.update(s => { s.record.emailSubject = event.target.value })
        LeadActivityEmailStore.update(s => { s.record.emailSubject = event.target.value });
    };

    const handleBodyTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        LeadActivityOutcomeStore.update(s => { s.record.emailBody = event.target.value })
        LeadActivityEmailStore.update(s => { s.record.emailBody = event.target.value });
    };

    const handleFromEmailTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        LeadActivityOutcomeStore.update(s => { s.record.emailFrom = event.target.value })
        LeadActivityEmailStore.update(s => { s.record.emailFrom = event.target.value });
    };

    if (hasLoaded) {
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box >
                                    <Grid container alignContent='left' spacing={2}>
                                        <Grid item xs={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                            <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                Incoming Email
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={10} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    label="From"
                                                    id="email-from"
                                                    value={outcomesRecord.emailFrom}
                                                    size="small"
                                                    onChange={handleFromEmailTextChange}
                                                    error={emailFromError}
                                                />
                                            </FormControl>
                                            {emailFromError &&
                                                <Typography variant="caption" noWrap sx={{ color: 'red' }} align="left">
                                                    From email address is required!
                                                </Typography>
                                            }
                                        </Grid>
                                        <Grid item xs={12} md={2} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                                            
                                        </Grid>
                                        <Grid item xs={12} md={12} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    label="Subject"
                                                    id="subject"
                                                    value={outcomesRecord.emailSubject}
                                                    size="small"
                                                    onChange={handleSubjectTextChange}
                                                    error={emailSubjectError}
                                                />
                                            </FormControl>
                                            {emailSubjectError &&
                                                <Typography variant="caption" noWrap sx={{ color: 'red' }} align="left">
                                                    Email subject is required!
                                                </Typography>
                                            }
                                        </Grid>
                                        <Grid item xs={12} md={12} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    label="Body"
                                                    multiline
                                                    rows={8}
                                                    value={outcomesRecord.emailBody}
                                                    placeholder="Email body..."
                                                    fullWidth
                                                    onChange={handleBodyTextChange}
                                                    error={emailBodyError}
                                                />
                                            </FormControl>
                                            {emailBodyError &&
                                                <Typography variant="caption" noWrap sx={{ color: 'red' }} align="left">
                                                    Email body is required!
                                                </Typography>
                                            }
                                        </Grid>
                                        <Grid item xs={12} md={12} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            <DoActivityOutcomes />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
    else {
        return <StandardSkeleton />
    }

}

export { DoActivityInboundEmail }

export default DoActivityInboundEmail;